/**
 * @typedef {import('./Response').default} Response
 * @typedef {import('../../../../App/shared/GroupService/Group').Group} Group
 */

import { groupService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {string} groupId
 * @param {boolean} [isGated]
 * @returns {Response}
 */
export default function useGetAdminVendors(groupId, isGated) {
	const [group, setGroup] = useState(/** @type {Group|null} */ (null));
	const [isError, setIsError] = useState(false);
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated]);

	async function fetchData() {
		setIsGettingData(true);

		try {
			const response = await groupService.getGroup(groupId);
			setGroup(response);
		} catch (error) {
			captureError(error);
			setIsError(true);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: group,
			isError,
			isGettingData,
		}),
		[group, isError, isGettingData]
	);
}
